import { render } from "./EmailVerify.vue?vue&type=template&id=24b2c16f&scoped=true"
import script from "./EmailVerify.vue?vue&type=script&lang=js"
export * from "./EmailVerify.vue?vue&type=script&lang=js"

import "./EmailVerify.vue?vue&type=style&index=0&id=24b2c16f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b2c16f"]])

export default __exports__